import React from "react";

const Column = (props) => {
    return (
        <div className={`${!props.strict ? 'col-12' : ''} ${props.className}`} id={props.id}>{props.children}</div>
    )
}

export default Column;